import React from 'react';
import './Drawcanvas.css';

function Tooltip(props) {
    return (
      <div className={"toolTip relative bg-white shadow-2xl w-2/3 lg:w-1/4 shadow-lg sm:p-5 p-4 text-base text-gray-700 text-xl place-content-center rounded overflow-hidden "}>
        <button className='absolute top-1 right-1 border border-8 rounded-full h-8 w-8 flex items-center justify-center' onClick={()=>props.dismiss("howTo")}>
          X
        </button>
        <h2 className='md:text-3xl text-lg border-b-4 mb-4 md:pb-2'>{props.header}</h2>
        <div className='md:text-lg text-sm'>
        {props.children}
        </div>
      </div>
    );
  
}

export default Tooltip;
